// import { HttpClient } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { firstValueFrom } from 'rxjs';
// import { environment } from '../../environments/environment';
// import { ApiMembresiaResponse } from '../../types/API.types';
// import { Sucursal } from '../../types/stores';
import { preloadedStores } from '../../data-preloaded/stores-data';
import { ApiMembresiaResponse } from '../../types/API.types';
import { Sucursal } from '../../types/stores';

// RESOLVERS
export async function getStores(): Promise<ApiMembresiaResponse<Sucursal[]>> {
  // const http = inject(HttpClient);
  // const url = `${environment.apiUrl}/${environment.apiVersion}${environment.endpoints.stores.get}`;
  try {
    return {
      success: true,
      message: 'Sucursales obtenidas correctamente',
      data: preloadedStores,
    };
    // return await firstValueFrom(
    //   http.get<ApiMembresiaResponse<Sucursal[]>>(url)
    // );
  } catch (error) {
    return {
      success: false,
      message: 'Error obteniendo sucursales',
      data: [],
    };
  }
}
